import { IProductAddOn } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import ProductAddonsBuilder from "./ProductAddonsBuilder";
import Separator from "@/app/components/lib/Separator";

interface Props {
  addOnBiulder: IProductAddOn[];
  state: any;
  setState: (state: any) => void;
  detailsCountaineMaxWidth?: number;
  disablechangeAddon?: boolean;
  productId?: number;
}

const AddOns: React.FC<Props> = ({
  addOnBiulder,
  state,
  setState,
  detailsCountaineMaxWidth,
  disablechangeAddon,
  productId,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {addOnBiulder?.map((addOn, key) => (
        <div key={key}>
          <Separator
            startLabel={
              <>
                {addOn.configurations.title}
                {addOn.configurations.is_required && (
                  <strong className="text-danger"> * </strong>
                )}
              </>
            }
            marginBottom={8}
          />
          <ProductAddonsBuilder
            detailsCountaineMaxWidth={detailsCountaineMaxWidth}
            addOn={addOn}
            state={state[addOn.configurations.key]}
            setState={(st) =>
              setState({ ...state, [addOn.configurations.key]: st })
            }
            disablechangeAddon={disablechangeAddon}
            selectedAddOns={state}
            productId={productId}
          />
        </div>
      ))}
    </div>
  );
};

export default AddOns;
